










import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { GPageBase } from '@/mixins';
import { Constants } from '@/constants/constants';
import GCompetencyAcademicAbility from '@/components/GCompetencyAcademicAbility.vue';
import { CourseResult, StudentCompetencyGrowth } from '@/models/student/student-competency-growth';
import { studentAllCompetencyModule } from '@/store/modules/frames/student-all-competency.module';
import { GEnum } from '@/constants/enum.defination';

@Component({
  name: 'GStudentRecordCompetencyComparison',
  components: { GCompetencyAcademicAbility },
  computed: {},
  methods: {},
})
export default class GStudentRecordCompetencyComparison extends Mixins(GPageBase) {
  studentID: number = 0;
  targets: number[] = [
    GEnum.AcademicAbilityElements.Thinking,
    GEnum.AcademicAbilityElements.Decisiveness,
    GEnum.AcademicAbilityElements.Expression,
    GEnum.AcademicAbilityElements.Individuality,
    GEnum.AcademicAbilityElements.Collaboration,
    GEnum.AcademicAbilityElements.Flexibility,
  ];

  created() {
    this.studentID = parseInt(this.$route.params.studentID);
  }

  mounted() {}

  get competencyIDs(): number[] {
    return Constants.CompetencyIDsBySortedType;
  }
  get sortDiffScore(): StudentCompetencyGrowth[] {
    return studentAllCompetencyModule.sortDiffScore;
  }
  get sortDiffScoreMap(): Map<number, StudentCompetencyGrowth> {
    const map: Map<number, StudentCompetencyGrowth> = new Map();
    studentAllCompetencyModule.sortDiffScore.map((s: StudentCompetencyGrowth) => {
      map.set(s.competencyID, s);
    });
    return map;
  }

  get academicThreeElementMap(): Map<number, StudentCompetencyGrowth> {
    const result: Map<number, StudentCompetencyGrowth> = new Map();

    // 思考力（論理的思考力）
    if (
      this.sortDiffScoreMap.has(GEnum.Competency.ID5) // 論理的思考力
    ) {
      this.sortDiffScoreMap.get(GEnum.Competency.ID5).competencyName = this.$t('ACADEMIC_ABILITY_ELEMENTS.THINKING').toString();
      result.set(GEnum.AcademicAbilityElements.Thinking, this.sortDiffScoreMap.get(GEnum.Competency.ID5));
    }

    // 判断力（決断力）
    if (
      this.sortDiffScoreMap.has(GEnum.Competency.ID18) // 決断力
    ) {
      this.sortDiffScoreMap.get(GEnum.Competency.ID18).competencyName = this.$t('ACADEMIC_ABILITY_ELEMENTS.DECISIVENESS').toString();
      result.set(GEnum.AcademicAbilityElements.Decisiveness, this.sortDiffScoreMap.get(GEnum.Competency.ID18));
    }

    // 表現力
    if (
      this.sortDiffScoreMap.has(GEnum.Competency.ID14) // 表現力
    ) {
      this.sortDiffScoreMap.get(GEnum.Competency.ID14).competencyName = this.$t('ACADEMIC_ABILITY_ELEMENTS.EXPRESSION').toString();
      result.set(GEnum.AcademicAbilityElements.Expression, this.sortDiffScoreMap.get(GEnum.Competency.ID14));
    }

    // 主体性
    if (
      this.sortDiffScoreMap.has(GEnum.Competency.ID3) && // 個人的実行力
      this.sortDiffScoreMap.has(GEnum.Competency.ID18) // 決断力
    ) {
      const studentCompetencyGrowth = this.getAvarageCourseResult(GEnum.Competency.ID3, GEnum.Competency.ID18, this.$t('ACADEMIC_ABILITY_ELEMENTS.INDIVIDUALITY').toString());
      if (studentCompetencyGrowth) {
        result.set(GEnum.AcademicAbilityElements.Individuality, studentCompetencyGrowth);
      }
    }

    // 協働性
    if (
      this.sortDiffScoreMap.has(GEnum.Competency.ID9) && // 自己効力
      this.sortDiffScoreMap.has(GEnum.Competency.ID20) // 影響力の行使
    ) {
      const studentCompetencyGrowth = this.getAvarageCourseResult(GEnum.Competency.ID9, GEnum.Competency.ID20, this.$t('ACADEMIC_ABILITY_ELEMENTS.COLLABORATION').toString());
      if (studentCompetencyGrowth) {
        result.set(GEnum.AcademicAbilityElements.Collaboration, studentCompetencyGrowth);
      }
    }

    // 多様性
    if (
      this.sortDiffScoreMap.has(GEnum.Competency.ID17) // 柔軟性
    ) {
      this.sortDiffScoreMap.get(GEnum.Competency.ID17).competencyName = this.$t('ACADEMIC_ABILITY_ELEMENTS.FLEXIBILITY').toString();
      result.set(GEnum.AcademicAbilityElements.Flexibility, this.sortDiffScoreMap.get(GEnum.Competency.ID17));
    }

    return result;
  }

  getAvarageCourseResult(firstID: number, secondID: number, competencyName: string): StudentCompetencyGrowth {
    const firstLatestResult: CourseResult = this.sortDiffScoreMap.get(firstID).latestCourseResult;
    const secondLatestResult: CourseResult = this.sortDiffScoreMap.get(secondID).latestCourseResult;
    if (new Date(firstLatestResult.examDate).getTime() === new Date(secondLatestResult.examDate).getTime()) {
      // 最新スコアのセット
      const avagage = (firstLatestResult.competencyScore + secondLatestResult.competencyScore) / 2;
      const studentCompetencyGrowth = new StudentCompetencyGrowth().deserialize({ competencyName: competencyName, courseResults: [new CourseResult().deserialize(firstLatestResult)] });
      studentCompetencyGrowth.latestCourseResult.competencyScore = avagage;

      // 前回スコアのセット
      const firstLastResult: CourseResult = this.sortDiffScoreMap.get(firstID).lastCourseResult;
      const secondLastResult: CourseResult = this.sortDiffScoreMap.get(secondID).lastCourseResult;
      if (new Date(firstLastResult.examDate).getTime() === new Date(secondLastResult.examDate).getTime()) {
        const avagage = (firstLastResult.competencyScore + secondLastResult.competencyScore) / 2;
        studentCompetencyGrowth.courseResults.push(new CourseResult().deserialize(firstLastResult));
        studentCompetencyGrowth.lastCourseResult.competencyScore = avagage;
      }
      return studentCompetencyGrowth;
    }
    return new StudentCompetencyGrowth().deserialize({ competencyName: competencyName, courseResults: [] });
  }
}
